// extracted by mini-css-extract-plugin
module.exports = {"canvasWrapper":"ExtendedContentCanvas_canvasWrapper__2evdf","show":"ExtendedContentCanvas_show__3YDZE"};